export default {
  isEmpty: (state) => !state.items.length
}



// WEBPACK FOOTER //
// ./src/store/modules/profilePosts/profilePostsGetters.js